import api from "../../config/http-common";

const getVisitordetailsByCardNumber = (payload) => {
  return api.securedAxios().get("/web/visit/card_number/" + payload.pinNumber);
};

const updateStatus = (payload) => {
  return api
    .securedAxios()
    .put(
      "/web/visit/updateStatus/" +
        payload.pinNumber +
        "?status=" +
        payload.status,
    );
};

const forceStatusUpdate = (payload) => {
  return api
    .securedAxios()
    .put("/web/visits/status/" + payload.id + "?name=" + payload.name);
};

const dymoPrinterForDashboard = (payload) => {
  return api.securedAxios().post("/web/visits/dymo/" + payload.id, payload);
};

const PinNumberService = {
  getVisitordetailsByCardNumber,
  updateStatus,
  forceStatusUpdate,
  dymoPrinterForDashboard,
};

export default PinNumberService;
